import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { WellnessNav, WellnessFooter } from './WellnessLanding';

export default function WellnessLookup() {
  const nav = useNavigate();
  const [code, setCode] = useState('');
  return (
    <div className="min-h-screen bg-[#faf7ef] text-[#2a2620]" style={{ fontFamily: 'Georgia, "Times New Roman", serif' }} data-testid="lookup-page">
      <WellnessNav />
      <div className="max-w-xl mx-auto px-6 py-20 text-center">
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Find your booking</h1>
        <p className="text-sm text-[#6b6358] mb-7 font-sans" style={{ fontFamily: 'Inter, sans-serif' }}>
          Enter the confirmation code we emailed you (e.g. DRR-ABCDEF)
        </p>
        <form
          onSubmit={(e) => { e.preventDefault(); if (code.trim()) nav(`/wellness/confirmation/${code.trim().toUpperCase()}`); }}
          className="flex gap-2 font-sans" style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6b6358]" />
            <input
              value={code} onChange={(e) => setCode(e.target.value)}
              placeholder="DRR-XXXXXX"
              className="w-full h-12 pl-10 pr-3 rounded-xl border border-[#e0d6c2] text-sm focus:border-[#2f5d50] focus:outline-none uppercase tracking-wider font-bold"
              data-testid="lookup-input"
            />
          </div>
          <button type="submit" disabled={!code.trim()} className="h-12 px-6 rounded-xl bg-[#2f5d50] text-white text-sm font-semibold disabled:opacity-50 hover:bg-[#244a40] transition" data-testid="lookup-submit">
            Find
          </button>
        </form>
      </div>
      <WellnessFooter />
    </div>
  );
}
